import React from 'react';
import BadgeMenuSelect from './BadgeMenuSelect';

/**
 * Liste canonique des états d'un dossier visa.
 * Identique à celle du dialog « Nouveau dossier » pour rester cohérent.
 */
export const ETATS_VISA = [
  'à traiter',
  'Formulaire complet',
  'en cours',
  'Vérification éligibilité',
  'En attente réception dossier',
  'Dossier reçu',
  'à vérifier',
  'Dossier en souffrance',
  'traité',
  'Annulé',
  'Refusé'
] as const;

interface EtatVisaSelectProps {
  /** Valeur actuelle de l'état (etat_visa) */
  value: string;
  /** Titre du visa, pour l'affichage « En cours » sur les eVisa */
  titre: string;
  /** Couleur associée à un état */
  getColor: (etat: string) => string;
  /** Appelé quand l'utilisateur choisit un nouvel état */
  onChange: (nouvelEtat: string) => Promise<void> | void;
  /** Taille du texte affiché au repos (px) */
  fontSize?: number;
}

/**
 * Badge d'état cliquable : au repos, affiche l'état coloré (comme avant) ;
 * au clic, ouvre un menu color-codé pour changer l'état directement dans la liste.
 */
const EtatVisaSelect: React.FC<EtatVisaSelectProps> = ({
  value,
  titre,
  getColor,
  onChange,
  fontSize = 14
}) => {
  // Libellé affiché au repos (mappings historiques conservés)
  const label =
    value === 'Formulaire complet'
      ? 'complet'
      : titre.toLowerCase().includes('evisa') && value === 'en cours'
      ? 'En cours'
      : value;

  return (
    <BadgeMenuSelect
      value={value}
      options={ETATS_VISA}
      getColor={getColor}
      onChange={onChange}
      label={label}
      title="Cliquer pour changer l'état"
      fontSize={fontSize}
    />
  );
};

export default EtatVisaSelect;
